<template>
<!--  <v-breadcrumbs :items="items" divider="/">-->
<!--    <v-breadcrumbs-item-->
<!--      v-for="item in breadcrumbs"-->
<!--      :key="item.text"-->
<!--      :disabled="item.disabled"-->
<!--    >-->
<!--      {{ item.text }}-->
<!--    </v-breadcrumbs-item>-->
<!--  </v-breadcrumbs>-->
</template>

<script>
export default {
  name: 'messages-breadcrumbs',
  data () {
    return {}
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => {}
    }
  },
  methods: {}
}
</script>
